export default __webpack_public_path__ + "static/image3-cb96eb277f0f3cc61dcb57093410bd45.png";